import { AppDispatch } from "@/app/store";
import { clearOverlayData, closeOverlay } from "./overlaySlice";

export const closeOverlayAsync =
  (delay = 500) =>
    (dispatch: AppDispatch) => {
      dispatch(closeOverlay());

      setTimeout(() => {
        dispatch(clearOverlayData());
      }, delay);
    };
